import React from 'react';
import TiltedCapabilityCard from '@/components/ui/tilted-capability-card';

interface TiltedFeatureSectionProps {
  title: string;
  features: {
    title: string;
    description: string;
  }[];
}

const TiltedFeatureSection: React.FC<TiltedFeatureSectionProps> = ({ title, features }) => {
  const accentColors = [
    'text-primary-700',
    'text-accent-600', 
    'text-secondary-600',
    'text-primary-700',
    'text-accent-600',
    'text-secondary-600'
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-bold text-center mb-12 text-gray-800">{title}</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <TiltedCapabilityCard
              key={index}
              title={feature.title}
              description={feature.description}
              titleColor={accentColors[index % accentColors.length]}
              containerHeight="300px"
              scaleOnHover={1.03}
              rotateAmplitude={6}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default TiltedFeatureSection;